<template>
  <v-container grid-list-lg pa-0 ma-0 fluid>
    <loading v-if="!isLoaded" />
    <v-layout row wrap v-else>
      <v-flex xs12 pl-4>
        <v-layout row wrap>
          <v-flex
            xs12
            messages
            px-5
            pt-4
            v-if="history && history.length"
            id="chat"
          >
            <v-layout
              row
              wrap
              messages__item
              v-for="(item, idx) in history"
              :key="idx"
              :class="{ 'messages__item-client': item.type === 0 }"
            >
              <v-flex
                xs12
                sm11
                messages__item-content
                :class="{ 'message-type-not-client': item.type == 1 }"
              >
                <!-- USER -->
                <div class="messages__item-name">
                  <span>
                    <span v-if="item.user"
                      >{{$t('components.leads.chat.username.1')}}:
                      {{ getUserName(item) }}
                      <em>({{ getRoleTitle(item.user.role) }})</em>
                    </span>
                    <span v-else>
                      <span v-if="item.type === 1">{{$t('components.leads.chat.username.1')}}</span>
                      <span v-else>{{$t('components.leads.chat.username.2')}}</span>
                    </span>
                  </span>
                </div>

                <!-- MESSAGE -->
                <div class="messages__item-message">
                  <v-overlay
                    :value="true"
                    :absolute="true"
                    color="blue"
                    opacity="0.8"
                    v-if="item.loading"
                  >
                    <v-progress-circular
                      indeterminate
                      size="48"
                    ></v-progress-circular>
                  </v-overlay>
                  <a v-if="hasItemDocument(item)" @click="getChatFile(item)"
                    ><span
                      class="raw_value"
                      v-html="getHistoryValue(item)"
                    ></span
                  ></a>
                  <div v-else-if="hasItemTelegramPhoto(item)">
                    <div v-if="item.data.message.uploadedPhoto">
                      <a
                        @click="
                          onShowModalImage(item.data.message.uploadedPhoto)
                        "
                        ><v-img
                          max-width="200"
                          min-height="200"
                          :src="getSrcFile(item.data.message.uploadedPhoto.id)"
                      /></a>
                    </div>
                    <a v-else @click="getChatTelegramPhoto(item, idx)">
                      <span
                        class="raw_value"
                        v-html="getHistoryValue(item)"
                      ></span>
                    </a>
                  </div>
                  <div v-else-if="hasItemTelegramContact(item)">
                    <div>
                      {{ item.data.message.contact.first_name }}
                      {{ item.data.message.contact.last_name }}
                    </div>
                    <div>
                      {{ item.data.message.contact.phone_number | formatPhone }}
                    </div>
                  </div>
                  <span
                    v-else
                    class="raw_value"
                    v-html="getHistoryValue(item)"
                  ></span>
                </div>

                <div class="messages__item-date d-flex">
                  <div class="flex-grow-1"></div>
                  <div>{{ getHistoryDate(item.created_at) }}</div>
                </div>
              </v-flex>
            </v-layout>
            <span id="chat-bottom"></span>
          </v-flex>
          <v-flex xs12 messages v-else>
            <h3 class="nocontent_title">{{ $t("components.bids.chat.emptyMessages") }}</h3>
          </v-flex>
        </v-layout>

        <v-divider class="mt-5" v-if="!read_only" />

        <v-layout
          row
          wrap
          justify-end
          align-end
          ppt-3
          mmt-2
          messages__add2
          v-if="!read_only"
        >
          <v-flex grow text-left>
            <v-textarea
              v-model="message"
              :disabled="isSendBlocked"
              :placeholder="$t('components.bids.chat.messageInput')"
              hide-details
              rows="2"
              outline
              auto-grow
              class="mt-0"
              ref="chatMessage"
            >
            </v-textarea>
          </v-flex>
          <v-flex shrink text-left>
            <!-- <v-btn @click="addFile" text icon :disabled="isSendBlocked">
              <v-icon color="primary">attachment</v-icon>
            </v-btn> -->
            <v-btn
              @click="addMessage"
              text
              icon
              :disabled="(!message && !message.length) || isSendBlocked"
            >
              <v-icon color="primary" class="mx-3">send</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-dialog v-model="isOpenFileDialog" width="500">
      <v-layout row wrap modal>
        <v-flex xs12 modal__wrapper>
          <form
            enctype="multipart/form-data"
            novalidate
            v-if="isInitial || isSaving"
          >
            <div class="dropbox">
              <input
                type="file"
                multiple
                :disabled="isSaving"
                @change="filesChange($event.target.name, $event.target.files)"
                class="input-file"
              />
              <p v-if="isInitial" v-html="
                  $t('components.client.documents.fileDialog.moveFileHtml')
                ">
              </p>
              <p class="pt-1" v-if="isInitial">
                <v-icon color="error" class="mr-2">warning</v-icon>{{ $t("components.client.documents.fileDialog.warningTitle") }}
                <v-icon color="error" class="ml-2">warning</v-icon>
                <br />{{
                  $t("components.client.documents.fileDialog.warningText")
                }}
              </p>

              <p v-if="isSaving">{{ $t("components.client.documents.fileDialog.loading") }}.</p>
            </div>
          </form>

          <div v-if="isError">
            <h2 v-if="isError && fileUploadError">{{ fileUploadError }}</h2>
            <p>
              <a href="javascript:void(0)" @click="reset()"
                >{{
                $t("components.client.documents.fileDialog.again")
              }}</a
              >
            </p>
          </div>

          <!--SUCCESS-->
          <div v-if="isSuccess">
            <h1>{{ $t("components.client.documents.fileDialog.loadSuccess") }}</h1>
          </div>
          <!--FAILED-->
          <div v-if="isFailed">
            <h1 class="mb-3">{{ $t("components.client.documents.fileDialog.errorLoadTitle") }}</h1>
            <p>
              <a href="javascript:void(0)" @click="reset()"
                >{{
                $t("components.client.documents.fileDialog.again")
              }}</a
              >
            </p>
            <div v-for="(error, idx) in uploadError" :key="`error_${idx}`">
              {{ error }}
            </div>
          </div>
        </v-flex>
      </v-layout>
    </v-dialog>

    <v-dialog
      v-model="imageModal.show"
      transition="slide-x-reverse-transition"
      mvax-width="800"
      content-class="image_preview"
    >
      <v-layout row wrap modal__block>
        <span class="modal__close" @click="closeImageModal"></span>
        <v-flex xs12 modal__wrapper>
          <h2 class="mb-4" v-if="imageModal.file">
            {{ imageModal.file.name }}
          </h2>
          <v-img
            v-if="imageModal.file"
            :src="getSrcFile(imageModal.file.id, false)"
          />
        </v-flex>
      </v-layout>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { apiCallTrue } from "@/utils/api";
import axios from "axios";
import moment from "moment";
import roles from "@/utils/data/roles";
import statusNames from "@/utils/data/statuses";
import formatPrice from "@/mixins/filters/formatPrice";
import formatPhone from "@/mixins/filters/formatPhone";
import showNotify from "@/services/noty";
import i18n from "@/services/i18n";
import { uploadChatFile } from "@/components/lib/file-upload.service";

const STATUS_INITIAL = 0,
  STATUS_SAVING = 1,
  STATUS_SUCCESS = 2,
  STATUS_FAILED = 3,
  STATUS_ERROR = 4;

export default {
  name: "LeadChat",
  mixins: [formatPrice, formatPhone],
  data: () => ({
    isLoaded: false,
    read_only: false,
    isSendBlocked: false,
    message: "",
    history: null,
    uploadedFiles: {},
    uploadError: null,
    currentStatus: null,
    isOpenFileDialog: false,
    fileUploadError: null,
    statusNames,
    cancelToken: null,

    imageModal: {
      show: false,
      file: null,
    },
  }),
  computed: {
    ...mapState({
      userId: (state) => state.user.profile.id,
      userRole: (state) => state.user.profile.role,
      wSocket: (state) => state.wSocket.message,
    }),
    isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed() {
      return this.currentStatus === STATUS_FAILED;
    },
    isError() {
      return this.currentStatus === STATUS_ERROR;
    },
  },
  watch: {
    wSocket(message) {
      this.getSocketMessage(message);
    },
  },
  props: {
    chatId: {
      type: String,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    closeImageModal() {
      this.imageModal.show = false;
      this.imageModal.file = null;
    },
    onShowModalImage(file) {
      this.imageModal.file = file;
      this.imageModal.show = true;
    },
    getSrcFile(fileId, thumb = true) {
      let resize = thumb ? "?resize=200,200" : "";
      return `${window.$api_url}v1/files/${fileId}/show-image${resize}`;
    },
    __afterGetMessages() {
      setTimeout(() => {
        let ch = document.getElementById("chat");
        if (ch) ch.scrollTop = ch.scrollHeight - ch.clientHeight;
      }, 550);
    },
    async getChatMessages() {
      if (this.cancelToken) {
        this.cancelToken.cancel("Отмена предыдущего ajax запроса");
      }
      const CancelToken = axios.CancelToken;
      this.cancelToken = CancelToken.source();
      await apiCallTrue({
        url: `v1/leads/${this.chatId}/history`,
        cancelToken: this.cancelToken.token,
      })
        .then((response) => {
          if (
            response &&
            response.data &&
            response.data.result &&
            response.data.data
          ) {
            this.history = response.data.data;
          } else {
            this.history = [];
          }
          this.isLoaded = true;
          const bottom = document.getElementById("chat-bottom");
          if (bottom) {
            setTimeout(() => {
              bottom.scrollIntoView({
                behavior: "smooth",
                block: "end",
              });
            }, 200);
          }
          this.__afterGetMessages();
        })
        .catch((error) => console.log(error, "get chat error"));
    },
    getUserName(item) {
      const name = item.user.full_name;
      const id = item.user.id;
      if (!name || !id) return "";
      return id === this.userId
        ? i18n.t("components.bids.chat.username.selfMessage")
        : name;
    },
    getRoleTitle(role) {
      const title = roles.filter((item) => item.id === role);
      return title.length
        ? title[0].name
        : i18n.t("components.bids.chat.username.anonim");
    },
    getHistoryDate(date) {
      moment.locale("ru");
      const now = new Date().toISOString().substr(0, 19);
      return moment(date).from(now);
      // return moment(date).fromNow();
    },
    hasItemDocument(item) {
      if (!item) return false;
      if (!item.data) return false;
      if (item.data.message) {
        if (item.data.message.document) return true;
      }
      return false;
    },
    hasItemTelegramPhoto(item) {
      if (!item) return false;
      if (!item.data) return false;
      if (item.data.message) {
        if (item.data.message.photo && item.data.message.photo.length > 0)
          return true;
      }
      return false;
    },

    hasItemTelegramContact(item) {
      if (!item) return false;
      if (!item.data) return false;
      if (item.data.message) {
        if (item.data.message.contact && item.data.message.contact.phone_number)
          return true;
      }
      return false;
    },

    getHistoryValue(item) {
      if (!item) return "";
      if (!item.data) return "";
      if (item.data.message) {
        if (item.data.message.text)
          return this.__foundLinkAndCreateLink(item.data.message.text);
        if (item.data.message.document) {
          return item.data.message.document.file_name;
        }
      }
      if (item.data.callback_query) {
        if (item.data.callback_query.data == "newLid")
          return i18n.t("components.leads.chat.historyValue.newLid");
        else return i18n.t("components.leads.chat.historyValue.pushedDefault", {btn: item.data.callback_query.data});
      }

      if (item.data.callback_query) {
        if (item.data.callback_query.data == "newLid")
          return i18n.t("components.leads.chat.historyValue.newLid");
        else return i18n.t("components.leads.chat.historyValue.pushedDefault", {btn: item.data.callback_query.data});
      }

      if (
        item.data.message &&
        item.data.message.photo &&
        item.data.message.photo.length > 0
      ) {
        return i18n.t("components.leads.chat.historyValue.givePhoto");
      }

      if (this.hasItemTelegramContact(item)) return "Contact";
      console.log("MESSAGE TYPE NOT SUPPORT", item);
      return "MESSAGE TYPE NOT SUPPORT";
    },
    __foundLinkAndCreateLink(output) {
      if (!output) return output;
      let matchValid = output.match(
        "(https?://(?:www.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9].[^s]{2,}|www.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9].[^s]{2,}|https?://(?:www.|(?!www))[a-zA-Z0-9]+.[^s]{2,}|www.[a-zA-Z0-9]+.[^s]{2,})"
      );
      if (matchValid && matchValid.length > 0) {
        let indexSubstr = matchValid.index;
        let prefix = "";
        if (indexSubstr > 0) {
          prefix = output.substr(0, indexSubstr);
        }
        let ArrList = output.substr(indexSubstr).split(/\s/);
        output = `<a target="_blank" href="${ArrList[0]}">${ArrList[0]}</a>`;
        ArrList.splice(0, 1);
        if (ArrList && ArrList.length > 0) {
          output += ArrList.join(" ");
        }
        return prefix + output;
      }
      return output;
    },
    getSignLink(item) {
      if (item.type !== 130) return;
    },
    getStatusName(id, key) {
      return this.statusNames[key][id].name
        ? this.statusNames[key][id].name
        : "";
    },
    addMessage() {
      this.isSendBlocked = true;
      const method = "POST";
      const data = {
        message: this.message,
      };
      apiCallTrue({
        url: `v1/leads/${this.chatId}/send-message`,
        method,
        data,
      })
        .then(() => {
          this.message = "";
        })
        .catch((error) => {
          showNotify("error", error);
        })
        .finally(() => {
          this.isSendBlocked = false;
        });
    },
    addFile() {
      this.isOpenFileDialog = true;
    },
    reset() {
      this.currentStatus = STATUS_INITIAL;
      this.uploadedFiles = [];
      this.uploadError = null;
    },
    save(formData) {
      this.currentStatus = STATUS_SAVING;

      uploadChatFile(
        formData,
        this.fromUser.children_id
          ? this.fromUser.children_id
          : this.bid.package.id
      )
        .then((response) => {
          if (response && response.result) {
            this.currentStatus = STATUS_SUCCESS;
            setTimeout(() => (this.isOpenFileDialog = false), 2000);
            setTimeout(() => this.reset(), 3000);
          } else {
            this.currentStatus = STATUS_ERROR;
            this.fileUploadError = response.message;
          }
        })
        .catch((error) => {
          this.fileUploadError = error.message;
          this.uploadError = error.response.data.validation;
          this.currentStatus = STATUS_FAILED;
          showNotify("error", error);
        });
    },
    filesChange(fieldName, fileList) {
      if (!fileList.length) return;

      const formData = new FormData();
      formData.append("type", 110);
      formData.append("file", fileList[0]);

      this.save(formData);
    },
    openBidPackage() {
      return (this.isPackageShow = true);
    },
    openBankItems() {
      this.isBankItemsOpen = true;
    },
    closeModal() {
      this.isBankItemsOpen = false;
    },
    openFileDialog(id) {
      this.bankId = id;
      this.isOpenFileDialog = true;
    },
    getChatTelegramPhoto(item, idx) {
      console.log("ITEM", this.history[idx], item);
      this.$set(this.history[idx], "loading", true);
      apiCallTrue({
        url: `v1/leads/get-telegram-photo/${item.id}`,
      })
        .then((response) => {
          this.$set(this.history, idx, response.data);
        })
        .catch((error) => {
          showNotify("error", error);
          this.$set(this.history[idx], "loading", false);
        });
    },
    async getChatFile(item) {
      await apiCallTrue({
        url: `v1/leads/get-telegram-file/${item.id}/${item.data.message.document.file_id}`,
      })
        .then((response) => {
          Object.assign(document.createElement("a"), {
            target: "_blank",
            href: response.data.data,
          }).click();
          console.log("re", response);
          // const link = document.createElement("a");
          // link.href = response.data.data;
          // link.setAttribute("target", "_blank");
          // document.body.appendChild(link);
          // link.click();
        })
        .catch((error) => showNotify("error", error));
    },

    getTypeName(mime) {
      if (!mime) return "";
      if (mime == "text/plain") return "default";
      const mimeArray = mime.split("/");
      const mimeTypeArray = mimeArray[1].split(".");
      if (mimeTypeArray.length > 3) {
        // ms word fix
        return mimeTypeArray[2];
      } else if (mimeTypeArray.length > 1) {
        // ms excel fix
        return mimeTypeArray[1];
      }

      return mimeArray[1];
    },
    getSocketMessage(message) {
      switch (message.type) {
        case 2:
          if (
            message &&
            message.action === "updateLead" &&
            parseInt(message.data) === parseInt(this.chatId)
          ) {
            console.log("ChAT updateLead", this.chatId, message);
            this.getChatMessages();
          }
          break;
      }
    },
  },
  mounted() {
    this.read_only = this.readOnly;
    this.getChatMessages();
  },
};
</script>
<style lang="scss">
.break-word {
  word-break: break-all;
}
ul.step-items {
  list-style-type: decimal;
  text-align: left;
  color: black;
  a {
    color: #3e3c3c;
  }
}
.v-card.cert-item {
  border-left: 5px solid green !important;
}

.messages {
  // border-top: 1px solid #dadada;
  max-height: 500px;
  overflow: auto;

  &__item {
    margin-bottom: 16px !important;

    &--signed {
      background: #404ce6 !important;
      color: #fff;

      &::before {
        border-right-color: #404ce6 !important;
      }
      .messages__item-date,
      .messages__item-name em {
        color: #fff;
        opacity: 0.4;
      }
    }

    &-content {
      background: #f7f7f7;
      border-radius: 5px;
      position: relative;
      z-index: 1;
      font-size: 14px;
      transition: all 0.3s ease;
      box-shadow: 0 0 0 #fff;

      &::before {
        content: "";
        position: absolute;
        height: 0;
        width: 0;
        left: -20px;
        bottom: 4px;
        transform: rotate(75deg);
        border: 17px solid transparent;
        border-right: 30px solid #f7f7f7;
        z-index: -1;
      }
    }

    &-client {
      justify-content: flex-end;

      .messages__item-content {
        background: #eaebf0;
        margin-right: 3px;

        &::before {
          left: auto;
          right: -15px;
          transform: rotate(105deg);
          border-right-color: #eaebf0;
        }
      }
    }
    //  .messages__item-content.message-type-not-client {
    //       background: #d8d8d8;
    //   }

    &-status-0 {
      box-shadow: 0 0 10px #aaa;
    }

    &-name {
      font-weight: 700;
      font-size: 0.9em;

      em {
        font-weight: normal;
        color: #666;
        font-size: 0.9em;
      }
    }

    &-message {
      word-break: break-all;
      .raw_value {
        white-space: pre-wrap;
      }
    }

    &-date {
      text-align: right;
      font-style: italic;
      color: #666;
      font-size: 0.8em;
    }

    &-recall {
      font-size: 14px;
      color: #4caf50;
      // text-decoration: underline;
      font-style: italic;
      cursor: pointer;
    }

    &-logo {
      box-sizing: content-box;
      height: 16px;
      width: 16px;
      line-height: 14px;
      display: inline-block;
      vertical-align: middle;
      text-align: center;
      margin: -4px 2px 0 0;
      background: #eee;
      border: 1px solid #dadada;
      border-radius: 50%;
      overflow: hidden;
      img {
        width: 16px;
        height: 16px;
      }
      strong {
        font-size: 9px;
        line-height: 1;
        color: #666;
      }
    }
  }
  &__add {
    border-top: 1px solid #eee;
  }
}
.v-textarea.v-text-field--enclosed textarea {
  margin-top: 0;
}

.bid {
  &__chat {
    &-files {
      border-right: 1px solid #dadada;
      &-download {
        .v-btn__content {
          font-weight: 400 !important;
          font-style: italic;
          color: #404ce6;
          padding: 0 !important;
        }
      }
    }

    &-file {
      display: inline-block;
      vertical-align: top;
      height: 25px;
      width: 25px;
      // background: url(../../assets/icons/default.svg) no-repeat center top;

      &-icon {
        padding-right: 0 !important;
        max-width: 33px;
      }

      &-name {
        font-size: 13px;
        font-weight: 700;
        cursor: pointer;
        // word-break: break-all;
        overflow-wrap: break-word;
        max-width: calc(100% - 33px);

        em {
          font-weight: 300;
          color: #aaa;
          font-style: italic;
        }
      }
    }
  }
}
#chat-bottom {
  position: relative;
  top: 300px;
}
.messages {
  &__item {
    &-file {
      color: #404ce6;
      font-size: 12px;
      font-weight: 700;
      font-style: italic;
      cursor: pointer;
    }
  }
}
</style>
